<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">search</i>
                        </div>
                        <h4 class="card-title ">Filtros</h4>
                    </div>
                    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset" novalidate="novalidate" autocomplete="off">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group bmd-form-group is-filled">
                                        <label for="administrator_id" class="bmd-label-floating">Administradora</label>
                                        <model-list-select
                                            class="form-control"
                                            :list="administrators"
                                            placeholder="Todas"
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.administrator_id">
                                        </model-list-select>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group bmd-form-group is-filled">
                                        <label for="team_id" class="bmd-label-floating">Equipe</label>
                                        <model-list-select
                                            class="form-control"
                                            :list="teams"
                                            placeholder="Todas"
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.team_id"
                                            @input="handlerChangeTeams">
                                        </model-list-select>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group bmd-form-group is-filled">
                                        <label for="team_id" class="bmd-label-floating">Vendedor</label>
                                        <model-list-select
                                            class="form-control"
                                            :list="salesmans"
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.salesman_id">
                                        </model-list-select>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.date_at != null}">
                                        <label for="interval" class="bmd-label-floating">Período</label>
                                        <date-picker
                                            range
                                            v-model="form.date_at"
                                            lang="pt-br"
                                            format="DD/MM/YYYY"
                                            placeholder="Escolha uma data"
                                            >
                                        </date-picker>
                                        <label v-if="validation.date_at != null" id="date_at-error" class="error" for="date_at">{{ validation.date_at }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <button type="reset" class="btn btn-fill btn-outline-danger">Limpar</button>
                            <button type="submit" class="btn btn-fill btn-rose">Gerar</button>
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import TypeProfiles from '@/services/modules/typeprofiles.service';
    import Utils from '@/services/utils.service';

    export default {
        computed: {
            administrators () {
                return this.$store.state.administrators.itens;
            },
            teams () {
                return this.$store.state.teams.itens;
            }
        },
        data() {
            return {
                form: {
                    administrator_id: null,
                    date_at: [Vue.moment().subtract(30, "days"), Vue.moment()],
                    date_by: 'pay_at',
                    salesman_id: null,
                    team_id: null
                },
                modalShow: false,
                salesmans: [],
                type_profiles: [],
                validation: {
                    date_at: null,
                    date_by: null
                }
            };
        },
        methods: {
            handlerChangeTeams(team_id) {
                var self = this;

                self.$root.$emit('onLoading');

                const response =  self.$store.dispatch('teams/get', team_id);

                response.then(function (_team) {
                    self.salesmans = _team.salesmans;
                    if (_team.supervisor && self.salesmans.some(_salesman => _salesman.id == _team.supervisor.id) == false) {
                        self.salesmans.push(_team.supervisor);
                    }
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            },
            goBack() {
                var self = this;
                self.modalShow = false;
            },
            onPrint() {
                Utils.printWithoutScreen("printReport");
            },
            onReset() {
                alert("Reset");
            },
            onSubmit() {
                var self = this;
                var form = self.form;
                var valid = true;
                var validation = self.validation;

                validation.date_at = null;
                validation.date_by = null;

                if (form.date_at[0] === null || form.date_at[1] === null) {
                    validation.date_at = "Favor informar o intervalo desejado!";
                    valid = false;
                }

                if (valid) {
                    var serialize = JSON.stringify(form);

                    window.open("print-contemplation?form=" + serialize, '_blank');
                }
            },
            async getDataAdministrators() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('administrators/all');

                response.then(function () {
                    self.getDataTeams();
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.getDataTeams();
                    self.$root.$emit("onLoading");
                });
            },
            async getDataTeams() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('teams/all');

                response.then(function () {
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
        },
        mounted() {
            var self = this;

            self.getDataAdministrators();

            setTimeout(() => {
                self.administrators.unshift(
                    {
                        id : '',
                        name : 'Todas'
                    }
                );
            }, 1000);

            self.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
                self.goBack();
            });
        }
    }
</script>